import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TipLinkModule } from '../../tip-link/tip-link.module';
import { TrDateComponent } from './tr-date.component';
import { DateMaskDirectiveModule } from '../../../directives';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        TipLinkModule,
        DateMaskDirectiveModule,
    ],
    exports: [ TrDateComponent ],
    declarations: [ TrDateComponent ],
})
export class TrDateModule {}
